export default [    //实时视频
    {
        path: "/promotion/videoInfo",  
        name:'videoInfo',
        meta: { navId:3 },
        component:() => import("@/views/promotion/videoInfo.vue")
    }
]